import { render, staticRenderFns } from "./PopupNoProductsAvailable.vue?vue&type=template&id=e4c77272&"
import script from "./PopupNoProductsAvailable.vue?vue&type=script&lang=js&"
export * from "./PopupNoProductsAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports